// extracted by mini-css-extract-plugin
module.exports = {"torna":"tornadalt_torna__pwREE"};